import { SingleOrderItem } from './SingleOrderItem';
import type { OrderItemProps } from '../types';

export const OrderItems = ({ orderItems }: { orderItems: OrderItemProps[] }) => {
  return (
    <div className="order-summary-container__order-items">
      {orderItems.map((item) => (
        <SingleOrderItem key={item.id} {...item} />
      ))}
    </div>
  );
};
